export const getTime = (date: Date) => {
	const hours = date.getHours()
	const minutes = date.getMinutes()
	const hoursDisplay = hours < 10 ? `0${hours}` : hours.toString()
	const minutesDisplay = minutes < 10 ? `0${minutes}` : minutes.toString()
	return `${hoursDisplay}:${minutesDisplay}`
}
